<template>
  <div  class="containerMembership">
    <b-container fluid  style="background-color:#FAFAFA;">
      <!-- header -->
      <HeaderBackMobile v-if="$store.state.company.block_address_navigation && $store.state.company.block_address_navigation === 'YES_LIST'" :noIcons="false" :leftAction="'menu'" :loginButton="true"  :noCart="true"/>
      <HeaderBackMobile v-else :noIcons="($store.state.user ? true : false)" :leftAction="$store.state.user ? 'back' : null" :noCart="true" :loginButton="$store.state.user ? true : false"/>
      <main>
        <template v-if="loading === false">
          <b-row v-if="companies.length">
            <b-col cols="12" class="company_list_title">
              Lojas próximas ao endereço:
            </b-col>
            <b-col cols="12" class="company_list_address" @click="openChoiceAddress()" :style="{color:getCssColor('primary_bt')}">
              {{$store.state.selectedAddressShort}}
              <font-awesome-icon v-if="$store.state.user" style="font-size:24px;padding-top:8px;" :icon="['fas', 'caret-down']"/>
            </b-col>
            <b-col cols="12" md="6" v-for="(company, idxo) in companies" v-bind:key="idxo" style="margin-top:15px;">
              <div @click="selectCompany(company)" class="companyCard">
                <b-row align-v="center" style="height:68px;">
                  <b-col cols="3">
                    <img :src="company.logo" style="max-width:100%;max-height:40px;"/>
                  </b-col>
                  <b-col>
                    <b-row>
                      <b-col class="company_list_name">{{company.companyBrand}} </b-col>
                    </b-row>
                    <b-row>
                      <b-col class="company_list_distancy">
                        <font-awesome-icon style="font-size:16px;color:#757F8C;padding-top:4px;" :icon="['far', 'dollar-sign']"/>
                        <font-awesome-icon style="font-size:16px;color:#757F8C;padding-top:4px;" :icon="['far', 'dollar-sign']"/> -
                        <font-awesome-icon style="font-size:22px;padding-top:8px;" :icon="['fal', 'map-marker-alt']"/>{{getCompanyDistance(company)}}
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col class="company_list_distancy">
                        <font-awesome-icon style="font-size:16px;color:#e8cf43;padding-top:4px;" :icon="['fas', 'star']"/>
                        <font-awesome-icon style="font-size:16px;color:#e8cf43;padding-top:4px;" :icon="['fas', 'star']"/>
                        <font-awesome-icon style="font-size:16px;color:#e8cf43;padding-top:4px;" :icon="['fas', 'star']"/>
                        <font-awesome-icon style="font-size:16px;color:#e8cf43;padding-top:4px;" :icon="['fas', 'star']"/>
                        <font-awesome-icon style="font-size:16px;color:#e8cf43;padding-top:4px;" :icon="['fas', 'star']"/> (500+)
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="2">
                    <font-awesome-icon style="font-size:24px;"  :icon="['fal', 'angle-right']"/>
                  </b-col>
                </b-row>
              </div>
            </b-col>
            <b-col cols="12" style="margin-top:16px;"><!-- spacer --></b-col>
          </b-row>
          <b-row v-else align-h="center">
            <!-- <b-col cols="12" class="company_list_title">
              Lojas próximas ao endereço:
            </b-col>
            <b-col cols="12" class="company_list_address" @click="openChoiceAddress()" :style="{color:getCssColor('primary_bt')}">
              {{$store.state.selectedAddressShort}}
              <font-awesome-icon v-if="this.$store.state.user && this.$store.state.user.adresses.length" style="font-size:24px;padding-top:8px;"  :icon="['fas', 'caret-down']"/>
            </b-col> -->
            <b-col cols="10 mt-3 mb-2" style="text-align:center;font-size:20px;font-weight:500;" :style="{color: getCssColor('primary_bt')}">
              Desculpe, ainda não cobrimos sua área de entrega!
            </b-col>

            <b-col cols="12 mt-2 mb-2" v-if="$store.state.activateOffers">
              <section @click="$router.push({path:'/offers'})"  style="width:calc(100% - 20px);max-width:500px; margin:0 auto;">
                <ActiveOfferStick>
                  {{$store.state.company.offers_information && $store.state.company.offers_information.callText ? $store.state.company.offers_information.callText : 'Ative ofertas para utilizar em nossas lojas físicas!'}}
                </ActiveOfferStick>
              </section>
            </b-col>

            <b-col cols="12 mt-2 mb-2" class="text-center" v-if="$store.state.company.out_of_range_banner">
              <a @click="redirectPath()">
                <template v-if="$mq === 'mobile'">
                  <img style="width:100%" class="banner_out" :src="'https://cdnimages.opa4.store/img/' + $store.state.company.companyId + '/banner/' + ($store.state.company.out_of_range_banner.xs_url || $store.state.company.out_of_range_banner.sm_url || $store.state.company.out_of_range_banner.md_url)"/>
                </template>
                <template v-else-if="$mq === 'tablet'">
                  <img style="width:100%" class="banner_out" :src="'https://cdnimages.opa4.store/img/' + $store.state.company.companyId + '/banner/' + ($store.state.company.out_of_range_banner.sm_url || $store.state.company.out_of_range_banner.md_url || $store.state.company.out_of_range_banner.xs_url)"/>
                </template>
                <template v-else>
                  <img class="banner_out" style="width:100%; max-width:1318px" :src="'https://cdnimages.opa4.store/img/' + $store.state.company.companyId + '/banner/' + ($store.state.company.out_of_range_banner.md_url || $store.state.company.out_of_range_banner.sm_url || $store.state.company.out_of_range_banner.xs_url)"/>
                </template>
              </a>
            </b-col>

            <b-col cols="12 mt-2 mb-2 pb-4" class="text-center">
              <button class="solid" @click="openChoiceAddress()" style="margin:0 auto;" :style="{backgroundColor: getCssColor('primary_bt')}">
                    Selecione outro endereço
                </button>
            </b-col>

          </b-row>
        </template>
        <template v-else>
          <InnerLoading />
        </template>
      </main>
    </b-container>

    <!-- address modal -->
    <OpaSlideModal 
      v-if="this.$store.state.user && this.$store.state.user.adresses.length" 
      title="Escolher Endereço" 
      direction="down"
      v-model="addressModal"
      @slideModalClose="() => addressModal = false"
      >
      <b-row style="overflow-y:auto; overflow-x:none; height:calc(100vh - 196px);">
        <b-col>
          <AddressList @selectedAddress="(addressId) => selectAddress(addressId)" />
        </b-col>
      </b-row>
      <b-row style="position:absolute;bottom:0px;height:140px;background-color:rgb(250, 250, 250);width:100%">
        <b-col>
          <b-row style="margin-top:10px;">
            <b-col style="text-align:center;">
              <button
                :style="{color: getCssColor('primary_bt'),
                borderColor: getCssColor('primary_bt')}"
                class="button_company_list_wire"
                @click="newAddress()"
                  >NOVO ENDEREÇO</button>
            </b-col>
          </b-row>
          <b-row  style="margin-top:10px;">
            <b-col  style="text-align:center;">
              <button
                class="button_company_list_solid"
                @click="verifyBlock()"
                :style="{backgroundColor: getCssColor('primary_bt')}"
                  >CONTINUAR</button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </OpaSlideModal>

  </div>
</template>

<script>
import HeaderBackMobile from '@/components/HeaderBackMobile.vue'
import colors from '@/mixins/colors'
import formaters from '@/mixins/formaters'
import LocationConn from '@/connection/location'
import InnerLoading from '@/components/InnerLoading'
import AddressList from '@/components/AddressList'
import OpaSlideModal from '@/components/OpaSlideModal'
import cartMixin from '@/mixins/cartMixin'
import { EventBus } from '@/behaviours/event-bus'
import navigation from '@/mixins/navigation'
import ActiveOfferStick from '@/components/ActiveOfferStick'

export default {
  
  data () {
    return {
      loading: true,
      lat:null,
      lng:null,
      companies: null,
      addressModal: false,
      firstModal: false
    }
  },

  mixins: [colors, formaters, cartMixin, navigation],
  components: {HeaderBackMobile, InnerLoading, AddressList, OpaSlideModal, ActiveOfferStick},

  created () {
    this.lat = this.$route.params.lat
    this.lng = this.$route.params.lng
    console.log('comapny_list')
    //clear old abandoned carts to change store
    this.clearCart()
  },

  mounted () {

    if (!this.lat && !this.lng && this.$store.state.user && this.$store.state.user.adresses.length) {
      console.log('START LIST BY LAST NEW ADDRESS', this.$store.state.user.adresses[this.$store.state.user.adresses.length -1].id)
      this.firstModal = true
      this.selectAddress(this.$store.state.user.adresses[this.$store.state.user.adresses.length -1].id)
    } else {
      console.log('NOT SELECTED')
      this.getCompaniesByLocation()
    }
  },

  methods: {
    async getCompaniesByLocation () {
      if (this.lat && this.lng){
        let result = await LocationConn.getCompaniesByLocation(this.lat, this.lng)
        console.log(result)
        this.loading = false
        console.log('result for new address list')
        if (!result.error){
          if (this.$store.state.company.block_address_navigation === "YES_LIST") {
            this.companies = result
          } else if (result && result.length > 0 ){
            let companyResult = result[0]
            console.log('GO TO PATH FROM LIST')
            this.selectCompany(companyResult)
          } else {
            console.log('Not Companies')
            this.companies = []
          }
        } else {
          EventBus.$emit('showAlert', 'error', result.msg)
        }
      } else {
        // erro nao esperado
        this.$store.state.showLoading = false
        console.log('NOT EXPECTED ERROR')
        localStorage.removeItem('userLogin')
        localStorage.removeItem('user')
        localStorage.removeItem('session_token')
        localStorage.removeItem('pushUserId')
        this.$router.push({path:'/welcome'})
      }
    },

    selectCompany (company) {
      // TODO get products by selected company
      this.$store.commit('setProducts', [])
      this.$store.commit('setProductList', [])
      this.$store.commit('setCategories', [])
      this.$store.state.productsIndex = []
      this.$store.state.productsIndexLoading = false
      this.$store.state.fetchingAllProducuts = false


      this.$store.state.choicedCompanyId = company.companyId
      this.$store.state.choicedCompany = company
      this.$router.push({path:'/home'})
      this.$store.commit('setLoadingView',false)
    },

    openChoiceAddress () {
      if (this.$store.state.user) {
        this.addressModal = true
        this.firstModal = true
      } else {
        this.$store.state.showLoading = false
        console.log('NOT LOGGED IN ON COMPANY LIST')
        localStorage.removeItem('userLogin')
        localStorage.removeItem('user')
        localStorage.removeItem('session_token')
        localStorage.removeItem('pushUserId')
        this.$router.push({path:'/welcome'})
      }
    },

    async selectAddress(addressId) {
      console.log('SELECT ADDR')
      this.selectedId = addressId
      // add the selected ID to session for use in checkout
      this.$store.state.selectedAddressId = addressId
      //
      if (this.$store.state.user && this.$store.state.user.adresses.length && this.firstModal) {
        this.addressModal = false
        let addr = this.$store.state.user.adresses.filter(addr => addr.id === addressId)[0]
        // addr short name to selects
        this.$store.state.selectedAddressShort = addr.shortName
        //
        this.lat = addr.latLong.lat
        this.lng = addr.latLong.lng
        this.$store.state.lastLatLongUri = addr.latLong.lat + '/' + addr.latLong.lng
        this.$store.state.showLoading = true
        await this.getCompaniesByLocation ()
        this.$store.state.showLoading = false
      }
    },

    async verifyBlock () {
      this.selectAddress(this.selectedId)
    },

    newAddress () {
      this.$store.state.newAddressOrigin = "company_list"
      this.$router.push({path:'/address'})
    },

    getCompanyDistance (company) {
      if (company.pinAdresses.length) {
        let cAddr = company.pinAdresses[0]
        return this.distanceBeetwen2LatLng(this.lat, this.lng, cAddr.lat, cAddr.lng)
      } else {
        return '...'
      }
    },

    redirectPath() {
      if (this.$store.state.company.out_of_range_banner.external_link) {
        window.open(this.$store.state.company.out_of_range_banner.external_link, '_blank');
      } else {
        let path = this.$store.state.company.out_of_range_banner.call_to_action
        this.gotToPath(path)
      }
    }
  }
}

</script>

<style lang="scss">

@import "@/css/_variables.scss";

.companyCard {
  padding:10px;
  background: #FFFFFF;
  box-shadow: 0px 4px 8px rgba(131, 131, 131, 0.15);
  border-radius: 4px;
  height:88px;
  cursor:pointer;
}

.company_list_title {
  margin-top:32px;
  color: #171D33;
  font-size: 22px;
  line-height: 20px;
  letter-spacing: 0.25px;

  @media screen and (max-width: $tablet_max) {
    margin-top:24px;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.25px;
  }
}

.company_list_address {
  margin-top:10px;
  font-size: 22px;
  line-height: 20px;
  letter-spacing: 0.25px;
  cursor:pointer;

  @media screen and (max-width: $tablet_max) {
    margin-top:10px;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.25px;
  }
}


.company_list_distancy {
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;

  color: #757F8C;
}

.company_list_name {
  font-weight: 500;
  font-size: 17px;
  line-height: 20px;
  letter-spacing: 0.15px;
  color: #171D33;

}

.button_company_list_solid {
  height:44px;
  width:350px;
  border-radius:6px;
  color:#ffffff;
  font-size:14px;
  border: 0px;
  font-weight: 500;
  @media screen and (max-width: $tablet_max) {
    height:44px;
    width:100%;
    max-width:204px;
    font-size:14px;
  }
}

.button_company_list_wire {
  height:44px;
  width:350px;
  border-radius:6px;
  font-size:14px;
  border: 1px solid;
  font-weight: 500;
  background-color:#ffffff;
  @media screen and (max-width: $tablet_max) {
    height:44px;
    width:100%;
    max-width:204px;
    font-size:14px;
  }
}

.banner_out {
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
}

</style>